export default "__VITE_ASSET__CtmAFQU7__"